import type { ApiClient } from '@prismo-io/schemas';

export const fetchExperienceTypes = async (
  client: ApiClient,
  term: string | null
) => {
  const baseQuery = client
    .from('quark_experience_types')
    .select()
    .order('name');

  if (!term) {
    const { data } = await baseQuery;

    return data || [];
  }

  const { data } = await baseQuery.ilike('name', `%${term}%`);

  return data || [];
};
